import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "Displayed offers",
    paragraphs: ["A promotion applies only when its product page, basket or checkout presentation identifies the eligible item and resulting price. The customer should review the basket before Pay Now; an offer that does not alter the displayed total has not been applied to that payment request."],
  },
  {
    title: "Offer period and stock",
    paragraphs: ["A start or end condition stated with an offer controls its availability. Product stock is not reserved merely by viewing a promotion or placing an item in the cart. An order already accepted at its displayed price is not repriced because an offer later begins or ends."],
  },
  {
    title: "Combining reductions",
    paragraphs: ["Two price reductions combine only when the offer presentation says they do. If a product already carries a struck-through price, any further reduction must appear in the basket total before payment to form part of the order."],
  },
  {
    title: "Corrections and misuse",
    paragraphs: ["Automated exploitation, fabricated eligibility or repeated attempts to defeat an offer condition can be rejected. A clear publication or calculation error is handled before acceptance under the pricing policy. A legitimate reduction is not withdrawn after acceptance solely because the store later changes the promotion."],
  },
  {
    title: "Returns and legal remedies",
    paragraphs: ["Buying during an offer preserves the protections attached to a dangerous, defective, broken, wrongly supplied or materially inaccurate item. An approved reimbursement starts from the price actually paid for that line. Delivery cost is added only when the established remedy or a non-excludable entitlement calls for it."],
  },
];

export default function OffersPolicy() {
  return <PolicyPage title="Discount & Promotion Policy" intro="Rules for reductions that are actually displayed in the catalogue, basket or checkout." sections={sections} related={[["Sale & Clearance", "/sale-clearance"], ["Payment, Pricing & Fraud", "/payment-pricing"], ["Returns, Refunds & Exchanges", "/returns"]]} />;
}
